import { ActionGroup, Flex, Title } from '@patternfly/react-core'
import { ExclamationCircleIcon } from '@patternfly/react-icons'
import * as React from 'react'

import { SmallButton } from './styles/small-button'

interface InfoPopoverProps {
  title?: string
  actionButtonText?: string
  body: React.ReactNode
  isDanger?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const InfoPopoverContent: React.FC<InfoPopoverProps> = ({
  title,
  actionButtonText,
  body,
  isDanger = false,
  onCancel,
  onConfirm,
}) => {
  const titleStyle = {
    color: isDanger ? 'red' : 'black',
  }

  return (
    <div>
      <Title headingLevel="h3" style={titleStyle}>
        {isDanger && <ExclamationCircleIcon />} {title}
      </Title>
      <div>{body}</div>
      <ActionGroup style={{ marginLeft: 'auto', marginTop: 10 }}>
        <Flex>
          <SmallButton key="cancel" variant="secondary" onClick={onCancel}>
            Cancel
          </SmallButton>
          <SmallButton
            key="confirm"
            variant={isDanger ? 'danger' : 'primary'}
            onClick={onConfirm}
          >
            {actionButtonText ?? 'Confirm'}
          </SmallButton>
        </Flex>
      </ActionGroup>
    </div>
  )
}
